import React from 'react';
import { useSwipeNavigation } from '../../hooks/useSwipeNavigation';
import { ViewType } from '../../types';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
  className?: string;
}

const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({
  children,
  currentView,
  onViewChange,
  className = '',
}) => {
  const views: ViewType[] = ['dashboard', 'posts', 'subscribers', 'analytics', 'subscriptions', 'moderation', 'customization'];
  
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipeNavigation({
    onViewChange,
    currentView,
    views,
  });

  return (
    <div
      className={`min-h-screen bg-gray-50 dark:bg-gray-900 ${className}`}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {children}
    </div>
  );
};

export default ResponsiveContainer;
